import { FormValidator } from '@estee/elc-form';
import { mixed } from 'yup';
import { PrimitiveValueType } from '../../domain/entities/Config';

interface IOneOfValidatorParams {
    values: PrimitiveValueType[];
    required: boolean;
    errorMessage: string;
}

// Extends FormValidator with RAMP field validations
export class RampFormValidator extends FormValidator {
    constructor() {
        super();
        this.registerValidation('oneOf', this.oneOf);
    }

    public oneOf = ({ values, required = false, errorMessage }: IOneOfValidatorParams) => {
        const schema = mixed().oneOf(values, errorMessage);
        if (required) {
            return schema.required(errorMessage);
        }

        return schema;
    };
}
